export default {
   'features': 'Funzionalità',
   'downloads': 'Download',
   'roadmap': 'Percorso',
   'price': 'Prezzo',
   'donate': 'Donazione',
   'feedback': 'Feedback',
   'panel': 'Pannello di controllo',
};
